export default "__VITE_ASSET__CwBT68II__"